import TextureSummaryChartGroup from './TextureSummaryChartGroup';
export default TextureSummaryChartGroup;
